import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_21791_8359)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 7.99979C0 3.58872 3.58881 0 8.00013 0C12.4114 0 16.0002 3.58872 16.0002 7.99979C16.0002 12.4111 12.4114 16 8.00013 16C3.58881 16 0 12.4111 0 7.99979ZM1.2845 7.99979C1.2845 11.7029 4.29708 14.7155 8.00013 14.7155C11.7031 14.7155 14.7157 11.7029 14.7157 7.99979C14.7157 4.29691 11.7031 1.28442 8.00013 1.28442C4.29708 1.28442 1.2845 4.29691 1.2845 7.99979ZM8.00016 5.33333C8.55245 5.33333 9.00016 4.88562 9.00016 4.33333C9.00016 3.78105 8.55245 3.33333 8.00016 3.33333C7.44788 3.33333 7.00016 3.78105 7.00016 4.33333C7.00016 4.88562 7.44788 5.33333 8.00016 5.33333ZM8.00016 6.66667H7.3335C7.15668 6.66667 6.98712 6.7369 6.86209 6.86193C6.73707 6.98695 6.66683 7.15652 6.66683 7.33333C6.66683 7.51014 6.73707 7.67971 6.86209 7.80474C6.98712 7.92976 7.15668 8 7.3335 8H8.00016V12C8.00016 12.1768 8.0704 12.3464 8.19543 12.4714C8.32045 12.5964 8.49002 12.6667 8.66683 12.6667C8.84364 12.6667 9.01321 12.5964 9.13823 12.4714C9.26326 12.3464 9.3335 12.1768 9.3335 12V8C9.3335 7.64638 9.19302 7.30724 8.94297 7.05719C8.69292 6.80714 8.35378 6.66667 8.00016 6.66667Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_21791_8359",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgInfo;
